"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISPLAY_EVENT_TYPES = exports.DISPLAY_EVENT_SEVERITIES = exports.DISPLAY_EVENT_CATEGORIES = void 0;
exports.DISPLAY_EVENT_CATEGORIES = [
    "lifecycle",
    "player",
    "connectivity",
    "content",
    "campaign",
    "config",
    "monitoring",
    "system",
];
exports.DISPLAY_EVENT_SEVERITIES = ["info", "warning", "error", "critical"];
exports.DISPLAY_EVENT_TYPES = [
    "power_on",
    "power_off",
    "blocked",
    "app_started",
    "app_foregrounded",
    "app_backgrounded",
    "boot",
    "restart",
    "crash",
    "frozen",
    "unresponsive",
    "player_loaded",
    "player_load_failed",
    "display_token_missing",
    "connected",
    "disconnected",
    "reconnected",
    "connectivity_lost",
    "connectivity_restored",
    "api_unreachable",
    "played",
    "skipped",
    "completed",
    "error",
    "started",
    "impression",
    "blocked",
    "updated",
    "schedule_updated",
    "pricing_updated",
    "field_updated",
    "health_check",
    "alert",
    "temperature_warning",
    "capability_unavailable",
    "screenshot_captured",
    "update_available",
    "update_applied",
    "storage_warning",
];
